import { Routes } from '@angular/router';

import { content } from './shared/routes/routes';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'maintenance',
    loadComponent: () => import('./maintenance/maintenance').then(m => m.Maintenance),
  },
  {
    path: '',
    loadComponent: () => import('./layout/layout').then(m => m.Layout),
    children: content,
  },
];
